module.exports = __webpack_public_path__ + "img/ad-roll.e4bc56fb.svg";